module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/eko-piknik/big/1-a8defc6df7354134fae4f03706ef7623.webp";